<template>
    <fencing-add-form></fencing-add-form>
</template>


<script>

    import FencingAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            FencingAddForm,
        },

    }
</script>

